var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 101,
    viewBox: "0 0 720 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_81940)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.398438,
    width: 720,
    height: 100,
    rx: 12,
    fill: "url(#paint0_linear_245_81940)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.625 25.5088C120.625 25.4719 120.627 25.4353 120.627 25.3985C120.627 5.38592 104.527 -10.8374 84.6662 -10.8374C69.9409 -10.8374 57.2849 -1.91731 51.7239 10.8517C50.3133 10.607 48.8637 10.4779 47.3839 10.4779C33.3648 10.4779 22 21.9297 22 36.0561C22 50.1825 33.3648 61.6343 47.3839 61.6343H122.61C132.54 61.6343 140.59 53.5225 140.59 43.5162C140.59 33.51 132.54 25.3985 122.61 25.3985C121.939 25.3985 121.277 25.4367 120.625 25.5088Z",
    fill: "url(#paint1_linear_245_81940)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.07 78.8917C690.07 78.8365 690.072 78.7817 690.072 78.7264C690.072 48.7249 665.936 24.4039 636.163 24.4039C614.087 24.4039 595.114 37.7764 586.778 56.9188C584.663 56.5519 582.49 56.3585 580.271 56.3585C559.255 56.3585 542.217 73.5263 542.217 94.7037C542.217 115.881 559.255 133.049 580.271 133.049H693.045C707.932 133.049 720 120.888 720 105.887C720 90.8866 707.932 78.7264 693.045 78.7264C692.04 78.7264 691.047 78.7837 690.07 78.8917Z",
    fill: "url(#paint2_linear_245_81940)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_81940",
    x1: 0,
    y1: 0.398437,
    x2: 4.32502,
    y2: 125.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_245_81940",
    x1: 81.295,
    y1: 38.8484,
    x2: 76.9988,
    y2: 7.72498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_245_81940",
    x1: 631.109,
    y1: 98.8897,
    x2: 624.668,
    y2: 52.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_81940"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.398438,
    width: 720,
    height: 100,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTablet);
export default __webpack_public_path__ + "static/media/pending_tablet.6355f22165f58099de80f6810cef5552.svg";
export { ForwardRef as ReactComponent };